import abstractModel from '../../../core/MercatelyModel';
import { MERCATELY_API_V2 } from '../../../constants/AppConstants';
import { msInboxApiUrl } from '../../../services/inbox/msInboxClient';
import { toSidebarPlatformKey } from '../../../services/inbox/inboxMsChatPlatform';

/** Listado y detalle principal del inbox: monolito Rails (mismo origen que antes). */
const resource = `${MERCATELY_API_V2}/inbox`;
const csrfToken = document.querySelector('[name=csrf-token]')?.content;

// Model
const model = abstractModel(resource);

model.getConversationById = async ({ conversationId, platform }) => {
  return model.get({}, { path: `${resource}/chat?chat_id=${conversationId}&platform=${platform}` });
};

// Methods - new
model.getConversations = async (params) => model.get(params, { path: resource });

/** Solo TikTok (u orígenes exclusivos MS): microservicio inbox; el resto de filtros usa getConversations (Rails). */
model.getMicroserviceConversations = async (params) => model.get(params, { path: msInboxApiUrl('/chats/inbox') });

/**
 * Todos los chats del microservicio de un mismo customer, en todas sus plataformas.
 * El MS ya scopea por el retailer del JWT, así que basta con el customer_id.
 */
model.getMicroserviceCustomerChats = async ({ customerId, perPage = 50 }) => model.get(
  {},
  { path: msInboxApiUrl(`/chats/inbox?customer_id=${customerId}&per_page=${perPage}`) }
);

model.getMessages = async ({ id, platform, page }) => model.get({}, { path: `${resource}/${id}/${platform}?page=${page}` });

model.getMicroserviceMessages = async ({ id, platform, page }) => model.get(
  {},
  { path: msInboxApiUrl(`/chats/inbox/${id}/${platform}?page=${page}`) }
);

model.getCustomerData = async ({ customerId }) => {
  return model.get({}, { path: `${resource}/${customerId}/customer_details` });
};

model.getCustomerOrderCount = async ({ customerId }) => {
  return model.get({}, { path: `${resource}/${customerId}/customer_orders_count` });
};
model.getUnreadChats = async (params) => model.get(params, { path: `${resource}/unread_chats` });

// Rails only knows whatsapp/messenger/instagram; MS chats carry long keys
// (whatsapp_bsp_messages, facebook_messages...), so normalize them here.
model.getCustomerLeadScore = async ({ customerId, platform }) => {
  return model.get({}, {
    path: `${resource}/${customerId}/lead_score?platform=${encodeURIComponent(toSidebarPlatformKey(platform))}`
  });
}

model.getLeadScoreHistory = async ({
  customerId, platform, limit = 20, before
}) => {
  const beforeParam = before ? `&before=${encodeURIComponent(before)}` : '';
  return model.get({}, {
    path: `${resource}/${customerId}/lead_score_history?platform=${encodeURIComponent(toSidebarPlatformKey(platform))}&limit=${limit}${beforeParam}`
  });
}

model.getCustomerFieldCaptures = async ({ customerId, platform }) => {
  return model.get({}, {
    path: `${resource}/${customerId}/field_captures?platform=${encodeURIComponent(toSidebarPlatformKey(platform))}`
  });
}

model.getCustomerDocuments = async ({ customerId }) => {
  return model.get({}, { path: `${resource}/${customerId}/customer_documents` });
}

model.uploadCustomerDocument = async ({ customerId, file }) => {
  const formData = new FormData();
  formData.append('file', file);

  return model.post(formData, { path: `${resource}/${customerId}/customer_documents`, csrfToken });
}

model.deleteCustomerDocument = async ({ customerId, documentId }) => {
  return model.remove({}, { path: `${resource}/${customerId}/customer_documents/${documentId}`, csrfToken });
}

export default model;
